import { resetCompletedItems } from '../../../../store/reducers/student/tracking/itemsTrackingActions';
import { StudentThunkDispatch } from '../../../../types/redux';
import { SettingsMenu as Component, SettingsMenuDispatchProps } from '../../components/student/SettingsMenu';
import { connect } from 'react-redux';

interface SettingsMenuOwnProps {
  onResetProgress: () => void;
}

function mapDispatchToProps(dispatch: StudentThunkDispatch, ownProps: SettingsMenuOwnProps): SettingsMenuDispatchProps {
  return {
    resetProgressAndCloseSidebar: () => {
      ownProps.onResetProgress();
      dispatch(resetCompletedItems);
    },
  };
}

export const SettingsMenu = connect(null, mapDispatchToProps)(Component);
